/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import textToSpeechActions from '../../actions/TextToSpeechActions';
import storeManager from '../../store/StoreManager';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';

class OptionsTTSChooser extends React.Component {
    static propTypes = {
        textToSpeech: PropTypes.object,
    };

    enableTTS = () => {
        const store = storeManager.getStore();
        store.dispatch(textToSpeechActions.setTextToSpeechIsEnabled(!this.props.textToSpeech.isEnabled));
    };

    render() {
        const { textToSpeech } = this.props;
        const current = textToSpeech.isEnabled ? 'enable' : 'disable';
        const options = ['enable', 'disable'];

        const choices = options.map((option) => {
            return {
                identifier: option,
                title: t(`options.tts-${option}`),
                isSelected: current === option,
            };
        });

        return (
            <div>
                <OptionsTopBar title={t('options.tts')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.enableTTS}
                        choices={choices}
                        {...getA11yAttributesV2({ a11yLabel: t('options.tts') })}
                    />
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        textToSpeech: state.textToSpeech,
    };
}

const OptionsTTS = connect(mapStateToProps, sessionActions)(OptionsTTSChooser);
export default OptionsTTS;
